
export const FETCH_STYLE_WISE_REPORTS_DATA_REQUEST = 'FETCH_STYLE_WISE_REPORTS_DATA_REQUEST';
export const FETCH_STYLE_WISE_REPORTS_DATA_SUCCESS = 'FETCH_STYLE_WISE_REPORTS_DATA_SUCCESS';
export const FETCH_STYLE_WISE_REPORTS_DATA_FAILURE = 'FETCH_STYLE_WISE_REPORTS_DATA_FAILURE';


export const FETCH_STYLE_WISE_REPORTS_DETAILS_DATA_REQUEST = 'FETCH_STYLE_WISE_REPORTS_DETAILS_DATA_REQUEST';
export const FETCH_STYLE_WISE_REPORTS_DETAILS_DATA_SUCCESS = 'FETCH_STYLE_WISE_REPORTS_DETAILS_DATA_SUCCESS';
export const FETCH_STYLE_WISE_REPORTS_DETAILS_DATA_FAILURE = 'FETCH_STYLE_WISE_REPORTS_DETAILS_DATA_FAILURE';

export const FETCH_STYLE_WISE_REPORT_BY_STYLE_ID_REQUEST = 'FETCH_STYLE_WISE_REPORT_BY_STYLE_ID_REQUEST';
export const FETCH_STYLE_WISE_REPORT_BY_STYLE_ID_SUCCESS = 'FETCH_STYLE_WISE_REPORT_BY_STYLE_ID_SUCCESS';
export const FETCH_STYLE_WISE_REPORT_BY_STYLE_ID_FAILURE = 'FETCH_STYLE_WISE_REPORT_BY_STYLE_ID_FAILURE';


export const FETCH_STYLE_WISE_REPORTS_STYLE_WISE_SUCCESS = 'FETCH_STYLE_WISE_REPORTS_STYLE_WISE_SUCCESS';

export const SET_SUMMARY_GRID_NAME_STYLE_WISE_REPORT_DK = 'SET_SUMMARY_GRID_NAME_STYLE_WISE_REPORT_DK';

export const CREATE_STYLE_STATUS_REPORT_DATA = 'CREATE_STYLE_STATUS_REPORT_DATA';


export const CREATE_USER_FORM_STYLE_WISE_REPORT = 'CREATE_USER_FORM_STYLE_WISE_REPORT';


export const FETCH_STYLE_STATUS_REPORTS_DATA_REQUEST = 'FETCH_STYLE_STATUS_REPORTS_DATA_REQUEST';
export const FETCH_STYLE_STATUS_REPORTS_DATA_SUCCESS = 'FETCH_STYLE_STATUS_REPORTS_DATA_SUCCESS';
export const FETCH_STYLE_STATUS_REPORTS_DATA_FAILURE = 'FETCH_STYLE_STATUS_REPORTS_DATA_FAILURE';

export const CREATE_STYLE_STATUS_REPORT_REQUEST = 'CREATE_STYLE_STATUS_REPORT_REQUEST';
export const CREATE_STYLE_STATUS_REPORT_SUCCESS = 'CREATE_STYLE_STATUS_REPORT_SUCCESS';
export const CREATE_STYLE_STATUS_REPORT_FAILURE = 'CREATE_STYLE_STATUS_REPORT_FAILURE';

export const FETCH_STYLE_WISE_REPORT_WITH_COLOUR_REQUEST = 'FETCH_STYLE_WISE_REPORT_WITH_COLOUR_REQUEST';
export const FETCH_STYLE_WISE_REPORT_WITH_COLOUR_SUCCESS = 'FETCH_STYLE_WISE_REPORT_WITH_COLOUR_SUCCESS';
export const FETCH_STYLE_WISE_REPORT_WITH_COLOUR_FAILURE = 'FETCH_STYLE_WISE_REPORT_WITH_COLOUR_FAILURE';

export const FETCH_STYLE_WISE_REPORT_WITH_CUD_COLOUR_REQUEST = 'FETCH_STYLE_WISE_REPORT_WITH_CUD_COLOUR_REQUEST';
export const FETCH_STYLE_WISE_REPORT_WITH_CUD_COLOUR_SUCCESS = 'FETCH_STYLE_WISE_REPORT_WITH_CUD_COLOUR_SUCCESS';
export const FETCH_STYLE_WISE_REPORT_WITH_CUD_COLOUR_FAILURE = 'FETCH_STYLE_WISE_REPORT_WITH_CUD_COLOUR_FAILURE';

export const CREATE_STYLE_WISE_REPORT_BY_MOVE_TO_CUTTING_REQUEST = 'CREATE_STYLE_WISE_REPORT_BY_MOVE_TO_CUTTING_REQUEST';
export const CREATE_STYLE_WISE_REPORT_BY_MOVE_TO_CUTTING_SUCCESS = 'CREATE_STYLE_WISE_REPORT_BY_MOVE_TO_CUTTING_SUCCESS';
export const CREATE_STYLE_WISE_REPORT_BY_MOVE_TO_CUTTING_FAILURE = 'CREATE_STYLE_WISE_REPORT_BY_MOVE_TO_CUTTING_FAILURE';


export const FETCH_COMPACTING_STATUS_REPORTS_DATA_REQUEST = 'FETCH_COMPACTING_STATUS_REPORTS_DATA_REQUEST';
export const FETCH_COMPACTING_STATUS_REPORTS_DATA_SUCCESS = 'FETCH_COMPACTING_STATUS_REPORTS_DATA_SUCCESS';
export const FETCH_COMPACTING_STATUS_REPORTS_DATA_FAILURE = 'FETCH_COMPACTING_STATUS_REPORTS_DATA_FAILURE';



export const POST_COMPACTING_STATUS_REPORTS_DATA_REQUEST = 'POST_COMPACTING_STATUS_REPORTS_DATA_REQUEST';
export const POST_COMPACTING_STATUS_REPORTS_DATA_SUCCESS = 'POST_COMPACTING_STATUS_REPORTS_DATA_SUCCESS';
export const POST_COMPACTING_STATUS_REPORTS_DATA_FAILURE = 'POST_COMPACTING_STATUS_REPORTS_DATA_FAILURE';



export const POST_COMPACTING_STATUS_REPORTS_DATE_WISE_REQUEST = 'POST_COMPACTING_STATUS_REPORTS_DATE_WISE_REQUEST';
export const POST_COMPACTING_STATUS_REPORTS_DATE_WISE_SUCCESS = 'POST_COMPACTING_STATUS_REPORTS_DATE_WISE_SUCCESS';
export const POST_COMPACTING_STATUS_REPORTS_DATE_WISE_FAILURE = 'POST_COMPACTING_STATUS_REPORTS_DATE_WISE_FAILURE';

export const FETCH_COMPACTING_STATUS_REPORTS_EDIT_DATA = 'FETCH_COMPACTING_STATUS_REPORTS_EDIT_DATA'


export const FETCH_COMPACTING_STATUS_REPORTS_EDIT_DATE_WISE = 'FETCH_COMPACTING_STATUS_REPORTS_EDIT_DATE_WISE'
